import { useState, useCallback } from 'react';
import { ConnectedWallet, WalletBalance } from '../types';

const STORAGE_KEY = 'mycryptoplanner_connected_wallets';

function load(): ConnectedWallet[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function save(wallets: ConnectedWallet[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(wallets));
}

export function useConnectedWallets() {
  const [wallets, setWallets] = useState<ConnectedWallet[]>(load);

  const addWallet = useCallback((wallet: ConnectedWallet) => {
    setWallets((prev) => {
      const next = [...prev, wallet];
      save(next);
      return next;
    });
  }, []);

  const removeWallet = useCallback((id: string) => {
    setWallets((prev) => {
      const next = prev.filter((w) => w.id !== id);
      save(next);
      return next;
    });
  }, []);

  const updateWallet = useCallback((id: string, balances: WalletBalance[]) => {
    setWallets((prev) => {
      const next = prev.map((w) => {
        if (w.id !== id) return w;
        return {
          ...w,
          balances,
          totalValueUsd: balances.reduce((s, b) => s + b.valueUsd, 0),
          lastSynced: Date.now(),
        };
      });
      save(next);
      return next;
    });
  }, []);

  return { wallets, addWallet, removeWallet, updateWallet };
}
